import moment from 'moment'
import { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { useApi } from '../api';
import { ICargo } from '../interfaces';

export const FtxReservationListItem = (props: any) => {
  const { t } = useTranslation()
  const [deleted, setDeleted] = useState(props['reservation']['deleted'])
  const [showModal, setShowModal] = useState(false)
  const [initAmount, setInitAmount] = useState(props['reservation']['amount'])
  const [amount, setAmount] = useState(props['reservation']['amount'])

  const api = useApi('SAI');
  
  if (props['strategy'] === null) {
    return <></>;
  }

  const token = props['strategy']['product'] ? props['strategy']['product'].split('-')[0].toUpperCase() : null
  const tokenImgPath = `https://ai.supercoin.network/img/coin/${token}.png`  

  const deleteReservation = () => {
    api.deleteFtxReservation(props['reservation']['idFtxReservation'], (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setDeleted(true)
        props['reservation']['deleted'] = true
      }
    })
  }

  const editReservation = () => {
    setShowModal(true)
  }

  const handleModalClose = () => {
    setShowModal(false)
  }

  const handleModalConfirm = () => {
    setShowModal(false)
    if (props['reservation']['targetPos'] !== 0 || props['reservation']['currentPos'] !== 0) {
      // return
    }
    api.updateFtxReservationAmount(props['reservation']['idFtxReservation'], Number(amount), (cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          setInitAmount(amount)
        } else {
          swal("Error!", "變更失敗", "error");
        }
    })
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-end pt-2 text-dark" style={{ "fontSize": "12px" }}>
        <div className="ai-icon bbg">{token ? <img style={{'width': '100%'}} src={tokenImgPath} alt="" /> : "無"}</div>
        <div className="d-flex flex-column flex-grow-1">
          <span className="text-dark font-weight-bold" style={{ "fontSize": "14px" }}>{props['strategy']['title']}
          </span>
          <div>({props['strategy']['strategy']})</div>
        </div>
        <div className="align-self-center">{t('date')}&nbsp;
          <span className="text-danger">{moment(props['reservation']['dateAdd']).format('YY-MM-DD')}</span>
          <div>{t('initVol')} {initAmount}</div>
        </div>
      </div>
      <div className="flex flex-row-reverse">
        <div className='mx-2'>
          { deleted === true ? <button className="btn btn-outline-danger cursor-pointer" disabled>{t('reservationCancel')}</button> : <button className="btn btn-outline-danger" onClick={deleteReservation}>{t('cancelReservation')}</button> }
        </div>
        <div className='mx-2'>
          { deleted === true ? <button className="btn btn-outline-danger cursor-pointer" disabled>{t('edit')}</button> : <button className="btn btn-outline-danger" onClick={editReservation}>{t('edit')}</button> }
        </div>
      </div>
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>更改下單金額</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-rose-500'>變更下單金額可能造成獲利計算發生錯誤<br />請再次確認是否進行金額之修改<br /></div>
          <Form.Group className="m-3">
            <Form.Label>下單金額</Form.Label>
            <Form.Control type="number" value={amount} onChange={(e) => {
              setAmount(e.target.value)
            }} />
            <Form.Text className="text-muted">
            若非必要，請勿調整下單金額
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            取消
          </Button>
          <Button variant="danger" onClick={handleModalConfirm}>
            變更
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="list-hr" style={{ "width": "100%" }}></div>
    </>
  )
}